import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@artosera/ui';
import { useElevation } from '../components/useElevation.js';
import pageStyles from '../styles/page.module.css';
import styles from './Associes/Associes.module.css';
import { ComptesAssocies } from './Associes/ComptesAssocies.js';
import { InvitationDialog } from './Associes/InvitationDialog.js';
import { PartageAssocies } from './Associes/PartageAssocies.js';
import { useAssocies } from './Associes/useAssocies.js';
import { VersementsAssocies } from './Associes/VersementsAssocies.js';

/**
 * Comptes associés et partage (ARTO-58, direction) : inviter, désactiver,
 * réactiver, réinitialiser la 2FA ; le partage entre associés et les
 * versements du mois. Rien n'est calculé à la place de la direction : parts et
 * versements sont saisis, `null` vaut « à saisir ».
 */
export function Associes(): JSX.Element {
  const { t } = useTranslation('console');
  const { executer, dialogue, enElevation } = useElevation();
  const { relire } = useAssocies();
  const [invitationOuverte, setInvitationOuverte] = useState(false);

  return (
    <section>
      <div className={pageStyles.entete}>
        <div>
          <h1>{t('associes.titre')}</h1>
          <p>{t('associes.texte')}</p>
        </div>
        <div className={pageStyles.actions}>
          <Button className={styles.inviter} onClick={() => setInvitationOuverte(true)}>
            {t('associes.inviter')}
          </Button>
        </div>
      </div>

      <div className={styles.sections}>
        <ComptesAssocies executer={executer} enElevation={enElevation} />
        <PartageAssocies />
        <VersementsAssocies />
      </div>

      <InvitationDialog
        // Une seule boîte à la fois : le formulaire s'efface pendant la vérification du code.
        ouvert={invitationOuverte && !enElevation}
        onOuvertChange={setInvitationOuverte}
        executer={executer}
        onInvite={() => void relire()}
      />
      {dialogue}
    </section>
  );
}
